/**
 * User Service - работа с данными пользователя
 */

import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export const userService = {
    /**
     * Получить баланс доната
     */
    getDonateBalance: async () => {
        const userId = localStorage.getItem("user-id");
        const userName = localStorage.getItem("user-login");
        const userPassword = localStorage.getItem("user-password");
        return apiClient.get(ENDPOINTS.UCP.GET_DONATE, {
            user_id: userId,
            user_name: userName,
            user_password: userPassword,
        });
    },

    /**
     * Получить настройки пользователя
     */
    getSettings: async () => {
        // Предполагается endpoint
        return apiClient.get(ENDPOINTS.UCP.UPDATE_SETTINGS);
    },

    /**
     * Обновить настройки
     */
    updateSettings: async (settings) => {
        return apiClient.post(
            ENDPOINTS.UCP.UPDATE_SETTINGS,
            settings,
            true,
            false,
        );
    },

    /**
     * Изменить пароль
     */
    changePassword: async (oldPassword, newPassword) => {
        return apiClient.post(
            ENDPOINTS.UCP.CHANGE_PASSWORD,
            { old_password: oldPassword, new_password: newPassword },
            true,
            false,
        );
    },

    /**
     * Проверить админку
     */
    checkAdmin: async () => {
        return apiClient.post(ENDPOINTS.UCP.CHECK_ADMIN);
    },
};

export default userService;
